export var alphabet = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz";



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-key/dist/key-alphabet.js
// module id = 292
// module chunks = 0